export class ServiceResultUser {
    success: boolean;
    errorMessage: string;
}
